import Common from '../../../../common/services/Common';
import Session, {
  IS_DEBUG,
  IS_LO,
  JWT_TOKEN,
} from '../../../../common/services/Session';
import { callDebugRestProxy } from '../../../../common/services/debugRestProxyServices';
import api from '../../../../common/utils/api';
import { isExceptionProgram } from '../EligibilityException';

export const splitByEligible = (products) =>
  products.reduce(
    ({ eligible, ineligible }, elem) =>
      elem.deleted === 0
        ? { ineligible, eligible: [...eligible, elem] }
        : { eligible, ineligible: [...ineligible, elem] },
    {
      eligible: [],
      ineligible: [],
    },
  );

export const getProgramGuidelines = async (programID) => {
  let result;
  if (Session.get(IS_DEBUG)) {
    result = await callDebugRestProxy({
      key: 'guidelines',
      pathParameters: { programId: programID },
    });
  } else if (Session.get(IS_LO)) {
    const patToken = await Common.getPATToken();
    const originId = await Common.getOriginId();
    result = await api.getProgramGuidelinesV1(
      { patToken, originId },
      programID,
    );
  } else {
    const jwtToken = await Session.get(JWT_TOKEN);
    result = await api.getProgramGuidelinesV2({ jwtToken }, programID);
  }
  return result;
};

export const removeSeconds = (dateTime) => {
  const dateTimeParts = dateTime.split(' ');
  const timeParts = dateTimeParts[1].split(':');
  const newTime = `${timeParts[0]}:${timeParts[1]}`;
  return `${dateTimeParts[0]} ${newTime} ${dateTimeParts[2]}`;
};

const matchInvestor = (program, investors) => {
  const lenderID = program.customLenderID || program.lenderID;
  if (investors.some((item) => item.id === 0)) {
    return program;
  }
  return investors.some(({ id }) => id === lenderID);
};

const matchProduct = (program, products) => {
  const { flagFilter } = program;
  return products.some(({ id }) => id === Math.abs(flagFilter));
};

export const filterPrograms = (programs, activeFilters) => {
  const { investor, product, special, term, flagged, exceptionsApplied } =
    activeFilters || [];
  let filteredPrograms = programs;
  const products = product.concat(special);
  if (investor.length) {
    filteredPrograms = filteredPrograms.filter((program) =>
      matchInvestor(program, investor),
    );
  }
  if (product.length || special.length) {
    filteredPrograms = filteredPrograms.filter((program) =>
      matchProduct(program, products),
    );
  }
  if (term?.label) {
    if (term.label === 'All') {
      filteredPrograms = filteredPrograms.filter(
        (program) => program.programTypeID,
      );
    } else {
      filteredPrograms = filteredPrograms.filter(
        (program) => program.programTypeID === term.value,
      );
    }
  }
  if (flagged) {
    filteredPrograms = filteredPrograms.filter(
      (program) => typeof program.nonOptions === 'string',
    );
  } else {
    filteredPrograms = filteredPrograms.filter(
      (program) => program.nonOptions === '',
    );
  }
  // "Exception Applied" filter: keep only programs with an applied exception.
  if (exceptionsApplied) {
    filteredPrograms = filteredPrograms.filter((program) =>
      isExceptionProgram(program),
    );
  }
  return filteredPrograms;
};

export const extractDescription = (adjustment) => {
  const extractDescFrom =
    adjustment?.adjustmentType === 'CorporatePriceConcession' ||
    adjustment?.adjustmentType === 'BranchPriceConcession'
      ? 'approvedReason'
      : 'description';

  if (
    adjustment?.[extractDescFrom] &&
    adjustment?.[extractDescFrom].includes('-')
  ) {
    return {
      ...adjustment,
      [extractDescFrom]: adjustment?.[extractDescFrom]
        ?.split('-')
        ?.pop()
        ?.trim(),
    };
  }
  return adjustment;
};
